
/*
*路由重定向
*/
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import {message, Spin} from 'antd';
import { getToken } from '../../../apis/api'
 

export default class Home extends Component{
    constructor(props){
        super(props);
        this.state={}
    }
    
    componentWillMount(){
        // console.log('access_token',this.getQueryString('access_token'))
        // console.log('key',this.getQueryString('key'))
        // console.log('openKey',this.getQueryString('openKey'))
        // console.log('code',this.getQueryString('code'))

        let access_token=this.getQueryString('access_token');
        // let code=this.getQueryString('code');

        // if(code){
        //     this.setState({flag:true},()=>{
        //         this.getToken(code);
        //     })
        // }else{
            if(access_token||sessionStorage.getItem('access_token')){
                if(access_token){
                    sessionStorage.setItem('access_token',this.getQueryString('access_token'));
                }
            }else{
                this.props.history.push('/login')
            }
        // }
        sessionStorage.setItem('key',this.getQueryString('key')?this.getQueryString('key'):'0')
        sessionStorage.setItem('openKey',this.getQueryString('openKey')?this.getQueryString('openKey'):'0')
    }

    componentDidMount() {
        
    }

    // getToken(code){
    //     let params={
    //         code:code,
    //         source:'cgj'
    //     }
    //     getToken(params).then( (data)=> {

    //         if(data.code === 0){
    
    //             let access_token=data.content.access_token;
    //             sessionStorage.setItem('access_token',access_token);
    //         }else{
    
    //             message.error(data.message); 
    //         }
    //     });
    // }

    //字符串截取----完成
    getQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r;
        if(window.location.search){
          r=window.location.search.substr(1).match(reg);
        }else{
          r=this.props.location.search.substr(1).match(reg);
        }
        if (r != null) return unescape(r[2]);
        return null;
    }
    render(){
        return(
            <div>

                <Redirect to="/home"/>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/page/App/common/RedirectIndex.js